import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function AddDesignationModal({ show, handleClose, onSave }) {
  const [formData, setFormData] = useState({
    name: "",
    dept: "",
    status: "Active",
  });

  useEffect(() => {
    if (show) {
      setFormData({
        name: "",
        dept: "",
        status: "Active",
      });
    }
  }, [show]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    onSave(formData);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fw-semibold">
          Add Designation
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Designation Name</Form.Label>
            <Form.Control
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter designation"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Department Name</Form.Label>
            <Form.Control
              name="dept"
              value={formData.dept}
              onChange={handleChange}
              placeholder="Enter department"
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Form.Select
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              <option>Active</option>
              <option>Inactive</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
        <Button className="btn-orange" onClick={handleSubmit}>
          Add Designation
        </Button>
      </Modal.Footer>
    </Modal>
  );
}